module.exports = __webpack_public_path__ + "img/payment-visa.10c3c81.svg";